import React from 'react'
import { LoginPipeline } from '@morningtrain/react-auth'
import RefreshEnvPipes from 'support/pipelines/RefreshEnvPipes'

export default () => (
  <LoginPipeline>
    <RefreshEnvPipes />
  </LoginPipeline>
)
